import { useEffect, useState } from 'react';
import { UsuariosService } from 'shared/services/usuarios/usuariosService';
import { useSessionUser } from 'shared/store/session';
import { useRolesActions, useRoles } from 'shared/store/roles';


export const useHasPermissionPath = (path: string) => {
  const user = useSessionUser();
  const rolesAction = useRolesActions();
  const roles = useRoles();
  
  useEffect(() => {
    async function loadRoles() {
      const response = await UsuariosService.getMe();

      if (!(response instanceof Error)) {
        rolesAction.setRoles(response.roles);
      }
    }
    loadRoles();
  }, [path]);

  if (!user) {
    return false;
  }

  const parts = path.split('/').filter(Boolean);
  if (parts.length > 1) {
    let acao = '';
    let temPermissao = false;
    switch (parts[1].toLowerCase()) {
    case 'listagem':
      acao = 'LIS';
      break;
    case 'detalhe':
      if (parts.length >= 3)
        parts[2].toLowerCase() == 'novo' ? acao = 'CRE' : acao = 'REA';
      else
        acao = 'REA';
      break;
    }
    roles.map((role) => {
      const permission = role.permissoes.find((P) => { return (P.codigoMenu.toLowerCase() == parts[0].toLowerCase() && P.codigoAcao == acao); });
      temPermissao = !!permission;
    });

    return temPermissao;

  }

  return false;
};

export const useHasPermissionAcao = (cdMenu: string, cdAcao: string) => {
  const roles = useRoles();
  
  let temPermissao = false;

  roles.map((role) => {
    const permission = role.permissoes.find((P) => { return (P.codigoMenu.toLowerCase() == cdMenu.toLowerCase() && P.codigoAcao == cdAcao); });
    temPermissao = !!permission;
  });

  return temPermissao;
};
